import { ADM, DIS, HUV1, HUV2 } from '@mummssoftware/utils/hope';
import defaults from '../../translations/en.json';

export const Daystoadmitdeadline = 'daystoadmitdeadline';
export const Daystodischargedeadline = 'daystodischargedeadline';
export const Demographicsstatus = 'demographicsstatus';
export const Bshowadminactionbuttons = 'bshowadminactionbuttons';

export const Approval = 'approval';
export const Due = 'Due';
export const Download = 'download';
export const Downloaded = 'downloaded';
export const Cmsapproved = 'cmsapproved';
export const Submit_Due = 'submit_due';

export const Hisadmineventdto = 'hisadmineventdto';
export const Hiscachedpatientitemdto = 'hiscachedpatientitemdto';

export const Sent = 'Sent';

export const APPROVE = 'APPROVE';
export const DUE = 'DUE';
export const CMS_ACCEPTANCE = 'CMS ACCEPTANCE';

export const vertical = 'vertical';
export const horizontal = 'horizontal';
export const SentandAccepted = 'Sent and Accepted';
export const Complete = 'Complete';
